import { render } from "./CodeHighlight.vue?vue&type=template&id=488b9616"
const script = {}

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/infrastructure/templates/prime/apollo/components/CodeHighlight.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "488b9616"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('488b9616', __exports__)) {
    api.reload('488b9616', __exports__)
  }
  
  module.hot.accept("./CodeHighlight.vue?vue&type=template&id=488b9616", () => {
    api.rerender('488b9616', render)
  })

}


export default __exports__